import React, { useState, useEffect, useRef, useCallback } from "react";
import Container from "../../../components/Container/Container";
import CustomButton from "../../../components/commons/CustomBtn";
import "./immoHeader.css";
import { ReactComponent as Lots } from "../../../components/assets/Lots.svg";
import { ReactComponent as Programs } from "../../../components/assets/programs.svg";
import { ReactComponent as Carte } from "../../../components/assets/carte.svg";
import DeepSearch from "./DeepSearch";
import { useDispatch } from "react-redux";
import { openModal } from "../../../redux/actions/modalActions";
import AddSecteurModal from "../../backOffice/components/AddSecteurModal";
import { ReactComponent as Settings } from "../../../components/assets/filterSettings.svg";
import EditCollaboratorModal from "../../backOffice/components/EditCollaboratorModal";

const ImmoHeader = ({
  activeView,
  setActiveView,
  carte = true,
  lots = true,
  programmes = true,
  filterInput,
  setFilterInput,
  addSecteur = false,
  handleSearch,
  backOffice = false,
  filterBtn = true,
  hideSearch = false,
  searchPlaceholder,
  changedOnglet,
}) => {
  const dispatch = useDispatch();
  const [localInput, setLocalInput] = useState(filterInput || "");

  const timeoutRef = useRef(null);
  const delayedSearch = useCallback(
    (e) => {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = setTimeout(() => {
        setFilterInput(e);
      }, 500);
    },
    [setFilterInput]
  );

  useEffect(() => {
    // Only set view to "lots" when not in backOffice mode
    if (!backOffice && changedOnglet) {
      ViewSetter("lots");
    }
  }, [changedOnglet, backOffice]);

  const handleInputChange = (e) => {
    const newValue = e.target.value;
    setLocalInput(newValue); // update input immediately

    delayedSearch(newValue); // update parent after debounce
  };
  useEffect(() => {
    setLocalInput(filterInput || "");
  }, [filterInput]);

  const ViewSetter = (type) => {
    setActiveView && setActiveView(type);
  };
  const handleDeepSearch = () => {
    dispatch(
      openModal({
        title: "Recherche avancée",
        content: <DeepSearch />,
      })
    );
  };
  const openAddSecteurModal = (documentId) => {
    dispatch(
      openModal({
        title: "Ajouter un secteur",
        content: <AddSecteurModal documentId={documentId} />,
      })
    );
  };
  const addUser = () => {
    dispatch(
      openModal({
        title: "Ajouter un utilisateur",
        content: <EditCollaboratorModal isCreating={true} />,
      })
    );
  };
  return (
    <Container className="p-0">
      <div className="d-flex bg-white headerRadius5 headerContainer align-items-center justify-content-between">
        <div className="d-flex gap-3">
          {!hideSearch && (
            <div className="d-flex align-items-center gap10 bg-white radius5 px-20 py-2px searchBar">
              <img
                src="./icons/search.svg"
                alt="search"
                height={16}
                width={16}
              />
              <input
                type="text"
                placeholder={
                  searchPlaceholder ||
                  (activeView === "lots"
                    ? "Rechercher un lot"
                    : "Rechercher un programme")
                }
                className="inputSearch border-0"
                value={localInput}
                onChange={(e) => handleInputChange(e)}
              />
            </div>
          )}

          {addSecteur && (
            <button
              onClick={openAddSecteurModal}
              className={`border-0 radius5 px-20 py-10 white hoverOpacity bg-pink cursor-pointer`}
            >
              <img
                src="./icons/add-secteur.svg"
                className="me-2"
                alt="add"
                height={24}
                width={24}
              />
              Ajouter un secteur
            </button>
          )}
        </div>

        <div className="headerButtons d-flex gap3 ">
          {lots && (
            <CustomButton
              onClick={() => ViewSetter("lots")}
              label="Voir les lots"
              buttonClass={`
            ${activeView === "lots"
                  ? "whiteSvg bg-pink white radiusTL5 radiusBL5 px-20 py-10"
                  : "bg-white-grey darkGrey radiusTL5 radiusBL5 px-20 py-10"
                }`}
              labelClass=" fs13 medium text-capitalize d-none d-xxl-flex"
              icon={<Lots />}
              iconClass="immoHeaderIcons "
            />
          )}
          {programmes && (
            <CustomButton
              onClick={() => ViewSetter("programmes")}
              label="Voir les programmes"
              buttonClass={`
            ${activeView === "programmes"
                  ? "whiteSvg bg-pink white  px-20 py-10"
                  : "bg-white-grey darkGrey  px-20 py-10"
                }
             ${carte ? "" : "radiusTR5 radiusBR5"}
          `}
              labelClass=" fs13 medium text-capitalize d-none d-xxl-flex"
              icon={<Programs />}
              iconClass="immoHeaderIcons"
            />
          )}
          {carte && (
            <CustomButton
              onClick={() => ViewSetter("carte")}
              label="Voir la carte"
              buttonClass={`
            ${activeView === "carte"
                  ? "whiteSvg bg-pink white radiusTR5 radiusBR5 px-20 py-10"
                  : "bg-white-grey darkGrey radiusBR5 radiusTR5 px-20 py-10"
                }
          `}
              labelClass=" fs13 medium text-capitalize d-none d-xxl-flex"
              icon={<Carte />}
              iconClass="immoHeaderIcons"
            />
          )}
        </div>
        {backOffice ? (
          <button
            title="Ajouter un utilisateur"
            onClick={addUser}
            className={`border-0 radius5 px-20 py-10 white hoverOpacity bg-pink cursor-pointer`}
          >
            <img
              src="./icons/add-user.svg"
              alt="add-user"
              height={24}
              width={24}
            />
          </button>
        ) : (
          <>
            {filterBtn && (
              <div className="filter d-flex align-items-center gap10">
                <p>Filtrer</p>

                <button className="toggle-button  " onClick={handleDeepSearch}>
                  <Settings />
                </button>
              </div>
            )}
          </>
        )}
      </div>
    </Container>
  );
};

export default ImmoHeader;
